/**
 * Bezpečný název PDF souboru z libovolného titulku.
 *
 * DŮLEŽITÉ: backend posílá název v hlavičce `Content-Disposition` (a jako
 * název e-mailové přílohy), která musí být latin-1/ASCII — české znaky
 * (ř, í, č…) jinak shodí generování PDF (`UnicodeEncodeError`) nebo se
 * v e-mailovém klientovi zobrazí rozbitě. Proto odstraníme diakritiku,
 * zbylé non-ASCII znaky a znaky nepovolené v názvech souborů (lomítka
 * z čísel typu „2026/001", dvojtečky, hvězdičky…).
 */
export function safeFileName(title: string): string {
  const ascii = title
    .replace(/\.pdf$/i, '')
    .normalize('NFD') // ř → r + ◌̌, í → i + ◌́ …
    .replace(/[^\x20-\x7E]/g, '') // odstraní kombinující diakritiku i zbytek non-ASCII
    .replace(/[\\/:*?"<>|]+/g, '_')
    .replace(/\s+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 80);
  return `${ascii || 'dokument'}.pdf`;
}
